// Colors
import colors from 'vuetify/lib/util/colors';

const palette = {
  cyber: {
    anchor: '#00E5FF',
    primarylight: '#D1C4E9',
    // primary: '#651FFF',
    primary: '#F06906',
    primarydark: '#311B92',
    secondarylight: '#84FFFF',
    secondary: '#00E5FF',
    secondarydark: '#006064',
    accentlight: '#F8BBD0',
    accent: '#FF4081',
    accentdark: '#D81B60',
  },
};

const theme = {
  ...palette.cyber,
};

export default theme;
